(function($) {
	$(document).ready(function(){

		$('.sortby').on('click', function(){
			$('.filter-sort-form#filter').removeClass('show');
			$('.filter-sort-form#sort').toggleClass('show');
		});

		$('.filterby').on('click', function(){
			$('.filter-sort-form#sort').removeClass('show');
			$('.filter-sort-form#filter').toggleClass('show');
		});

	});
})(jQuery); // Fully reference jQuery after this point.